import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BarChart3Icon, BookOpenIcon, DatabaseIcon, MapPinIcon } from 'lucide-react';
import { useDefinitions } from '../../contexts/DefinitionsContext';
export function BrandMark() {
  return <div className="flex items-center gap-3" data-id="element-254" data-mp="2mym6okp0qeux">
      <img src="https://cdn.magicpatterns.com/uploads/g8DoSfjozQkKRnc2KRCLJd/I9_Logo_Hi_Res_Multicolor.png" alt="i9 Sports" className="h-10 w-auto shrink-0" data-id="element-255" data-mp="2rrxcqjm0arls" />
      <div className="border-l border-line pl-3 text-[11px] font-semibold leading-tight text-ink-muted" data-id="element-256" data-mp="30ru1smcb5shd">
        Franchise
        <br data-id="element-257" data-mp="35s89u4dwt2fe" />
        Performance
      </div>
    </div>;
}
const itemClass = (active: boolean) => `relative flex w-full items-center gap-2.5 rounded-md px-3 py-2 text-left text-[13px] transition-colors duration-150 ${active ? 'bg-navy-50 font-semibold text-navy' : 'font-medium text-ink-muted hover:bg-canvas hover:text-ink'}`;
const Marker = () => <span className="absolute inset-y-1.5 left-0 w-[3px] rounded-r bg-accent" data-id="element-258" data-mp="1w02njoysssnp" />;
export function Sidebar() {
  const {
    pathname,
    search
  } = useLocation();
  const {
    open
  } = useDefinitions();
  const onDashboard = pathname === '/';
  const onDrilldown = pathname.startsWith('/territory/');
  return <aside className="sticky top-0 hidden h-screen w-60 shrink-0 flex-col border-r border-line bg-white lg:flex" data-id="element-259" data-mp="1i8nzh3q1a19s">
      <div className="flex h-[68px] items-center border-b border-line px-5" data-id="element-260" data-mp="2ezgj2bc6ebgb">
        <BrandMark data-id="element-261" data-mp="29zu705833193" />
      </div>
      <nav aria-label="Dashboard navigation" className="flex-1 overflow-y-auto px-3 py-4" data-id="element-262" data-mp="29zluiefvhxyf">
        <ul className="space-y-0.5" data-id="element-263" data-mp="25xqqh26k56gy">
          <li data-id="element-264" data-mp="25wp8sev1dlq9">
            <Link to={`/${search}`} className={itemClass(onDashboard)} aria-current={onDashboard ? 'page' : undefined} data-id="element-265" data-mp="260cyt419vq08">
              {onDashboard && <Marker data-id="element-266" data-mp="ujmphc1jyi2e" />}
              <BarChart3Icon className="h-4 w-4 shrink-0" data-id="element-267" data-mp="uk4x14to0ipm" />
              Member Stats
            </Link>
          </li>
          {onDrilldown && <li data-id="element-268" data-mp="pmd01we5y6ek">
              <span className={`${itemClass(true)} pl-8`} aria-current="page" data-id="element-269" data-mp="r1fk0cxwrjln">
                <Marker data-id="element-270" data-mp="qzcppgpq34b4" />
                <MapPinIcon className="h-4 w-4 shrink-0" data-id="element-271" data-mp="w0se9ir3zsy9" />
                Territory drillthrough
              </span>
            </li>}
          <li data-id="element-272" data-mp="i07w8ot0q15t">
            <button type="button" onClick={() => open()} className={itemClass(false)} data-id="element-273" data-mp="i2ke71ys0biv">
              <BookOpenIcon className="h-4 w-4 shrink-0" data-id="element-274" data-mp="m09pqaolnoa0" />
              Metric definitions
            </button>
          </li>
        </ul>
      </nav>
      <div className="m-3 rounded-md border border-dashed border-caution/40 bg-caution-soft p-3 text-[11.5px] leading-relaxed text-caution" data-id="element-275" data-mp="d1wii2zlr6ib">
        <div className="mb-1 flex items-center gap-1.5 font-semibold" data-id="element-276" data-mp="3ujpkbmbze884">
          <DatabaseIcon className="h-3.5 w-3.5" data-id="element-277" data-mp="3cmryrkepvwb" />
          Illustrative sample data
        </div>
        Scoping prototype for Jeremy and Adaptive. No figures are live or connected to Connect / Power BI.
      </div>
    </aside>;
}